import { useClientsQuery } from "@graphql/clients/clients.g";
import { isEmpty } from "lodash";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";

import { GettingStartedHeader } from "@components/Headers";

import { Box } from "@design-system/Box/Box";
import { Spinner } from "@design-system/Spinner/Spinner";

import { routes } from "@pages/routes";

export const GettingStartedLayout = () => {
  const clientsQuery = useClientsQuery();
  const navigate = useNavigate();
  const clients = clientsQuery.data;

  useEffect(() => {
    if (clientsQuery.isSuccess && !isEmpty(clients)) {
      navigate(routes.portal.dashboard.$buildPath({}), {
        viewTransition: true,
        replace: true,
      });
    }
  }, [clients, clientsQuery.isSuccess, navigate]);

  if (clientsQuery.isPending || (clientsQuery.isSuccess && !isEmpty(clients))) {
    return (
      <Box align="center" justify="center" stretch>
        <Spinner size={24} />
      </Box>
    );
  }

  return (
    <>
      <GettingStartedHeader />
      <Outlet />
    </>
  );
};
